import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import LoadingIndicator from 'components/LoadingIndicator';
import SafeMarkdown from 'components/SafeMarkdown';
import { errorShape } from 'utils/shapes';

function TermsOfServiceContent({ termsOfServiceData }) {
  const { termsOfServiceAsMarkdown, loading, error } = termsOfServiceData;

  let content;
  if (loading) {
    content = <LoadingIndicator />;
  } else if (error || !termsOfServiceAsMarkdown) {
    content =
      'An error occured while fetching the terms of service. Please try again.';
  } else {
    content = (
      <SafeMarkdown
        source={termsOfServiceAsMarkdown.termsOfService}
        role="article"
      />
    );
  }

  return <div className="terms-of-service-content">{content}</div>;
}

TermsOfServiceContent.propTypes = {
  termsOfServiceData: PropTypes.shape({
    termsOfServiceAsMarkdown: PropTypes.shape({
      termsOfService: PropTypes.string
    }),
    loading: PropTypes.bool,
    error: errorShape
  })
};

const QUERY_GET_TERMS = gql`
  query MyGetTOS {
    termsOfServiceAsMarkdown {
      termsOfService
    }
  }
`;

const withData = compose(
  graphql(QUERY_GET_TERMS, { name: 'termsOfServiceData' })
);

export default withData(TermsOfServiceContent);
